function bestemMiljo(): 'stm' | 'atm' | 'prod' {
    const overrideEnv = window["ENV"]
    if(overrideEnv) {
        if(overrideEnv === 'utv' || overrideEnv === 'dev') return 'stm';
        if(overrideEnv === 'atm' || overrideEnv === 'test') return 'atm';
    }
    const originContains = (url) => (window.location.origin.toString().indexOf(url) != -1);
    if (originContains('utv.vegvesen.no') || originContains('localhost:') || originContains('utv.atlas.vegvesen.no')) {
        return 'stm';
    } else if (originContains('test.vegvesen.no') || originContains('test.atlas.vegvesen.no')) {
        return 'atm';
    }
    return 'prod';
}

export { bestemMiljo }